<template>
  <Dialog
    @submit="onSubmit"
    :title="title"
  >
    <form @submit.prevent="onSubmit">
      <div class="form-group">
        <label for="amount">Amount* <span class="badge badge-warning">{{trx.currency}}</span></label>
        <input
          type="number"
          v-validate="'required'"
          id="amount"
          name="amount"
          class="form-control"
          :class="{'is-invalid': errors.has('amount')}"
          v-model.trim="amount"
          autofocus
        >
        <small v-show="errors.has('amount')" class="invalid-feedback">
          {{ errors.first('amount') }}
        </small>
      </div>

      <div class="form-group">
        <label for="description">Description*</label>
        <textarea
          class="form-control main-textarea"
          rows="3"
          v-model="notes"
          v-validate="'required'"
          id="description"
          name="description"
          :class="{'is-invalid': errors.has('description')}"
          placeholder="Enter description"
        ></textarea>
        <small v-show="errors.has('description')" class="invalid-feedback">
          {{ errors.first('description') }}
        </small>
        <div class="custom-control custom-checkbox mr-sm-2 mb-3 mt-3">
          <input type="checkbox" class="custom-control-input" id="checkbox0" value="check" v-model="transaction.invalidateLead">
          <label class="custom-control-label" for="checkbox0">Invalidate the Lead</label>
        </div>
      </div>
    </form>
  </Dialog>
</template>

<script>
import Switches from 'vue-switches';
import Dialog from '@/components/Dialog';
import ModalMixin from '@/mixins/ModalMixin';

import CREATE_TRANSACTION from '@/graphql/Transactions/NewLeadTransaction.gql';

export default {
  name: 'refund-lead-transaction',
  mixins: [ModalMixin],
  components: {
    Dialog,
    Switches,
  },
  props: {
    trx: Object,
  },
  data() {
    return {
      transaction: {
        amount: '',
        notes: '',
        invalidateLead: true,
      },
    };
  },
  mounted() {
    if (this.trx) {
      this.transaction.amount = -this.trx.amount;
    }
  },
  computed: {
    title() {
      return `Refund Lead #${this.trx.leadId}`;
    },
    amount: {
      get() {
        return (this.transaction && this.transaction.amount) || '';
      },
      set(val) {
        this.transaction.amount = val;
      },
    },
    notes: {
      get() {
        return (this.transaction && this.transaction.notes) || '';
      },
      set(val) {
        this.transaction.notes = val;
      },
    },
  },
  methods: {
    async onSubmit() {
      try {
        const isValid = await this.$validator.validateAll();
        if (!isValid) {
          return;
        }
      } catch (e) {
        return;
      }

      this.createTransaction();
    },

    createTransaction() {
      this.$apollo
        .mutate({
          mutation: CREATE_TRANSACTION,
          variables: {
            id: this.trx.companyId,
            input: {
              ...this.transaction,
              leadId: this.trx.leadId,
              currencyId: this.trx.currencyId,
            },
          },
          refetchQueries: ({ data }) => {
            const response = data.createTransaction;
            return response && response.success ? ['transactions'] : [];
          },
        })
        .then(() => {
          this.$notify({
            group: 'success',
            type: 'success',
            text: 'Transaction was created',
          });
          this.close();
        })
        .catch(e => {
          this.$notify({
            group: 'error',
            type: 'error',
            text: e.message,
          });
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.form-group {
  margin-bottom: 12px;
}
.vue-switcher {
  margin-left: 20px;
  margin-bottom: 0;
  top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/modals/LeadRefundModal.vue